import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import { useAuth } from "@/hooks/useAuth";

// Lazy load below-the-fold components
const HowItWorks = lazy(() => import("@/components/HowItWorks"));
const CTASection = lazy(() => import("@/components/CTASection"));
const MarketplaceActivity = lazy(() => import("@/components/MarketplaceActivity"));


const Index = () => {
  const { user } = useAuth();
  
  return <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Ask4gems - Open Gemstone Sourcing Network</title>
        <meta name="description" content="Open gemstone sourcing network where buyers post requests and sellers contact them directly with matching offers. Deal with zero commission and no subscription." />
        <link rel="canonical" href="https://www.ask4gems.com" />
        <meta property="og:title" content="Ask4gems - Open Gemstone Sourcing Network" />
        <meta property="og:description" content="Open gemstone sourcing network where buyers post requests and sellers contact them directly with matching offers. Deal with zero commission and no subscription." />
        <meta property="og:url" content="https://www.ask4gems.com" />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content="Ask4gems - Open Gemstone Sourcing Network" />
        <meta name="twitter:description" content="Open gemstone sourcing network where buyers post requests and sellers contact them directly with matching offers. Deal with zero commission and no subscription." />
      </Helmet>

      <Header />
      <main className="flex-1 min-h-[calc(100vh-4rem)]">
        <HeroSection />
        <Suspense fallback={<div className="py-20" />}>
          <HowItWorks />
          
          <MarketplaceActivity />
          {!user && <CTASection />}
        </Suspense>
      </main>
      <footer className="border-t border-border py-8">
        <div className="container text-center text-sm text-muted-foreground">
          <span>© 2026 Ask4gems – All rights reserved</span>
          <span className="mx-2">|</span>
          <Link to="/contact" className="hover:text-primary transition-colors">Contact</Link>
          <span className="mx-2">|</span>
          <Link to="/terms" className="hover:text-primary transition-colors">Rules and Terms of Use</Link>
        </div>
      </footer>
    </div>;
};
export default Index;